<template>
  <div class="drawer__header" data-js="get-height">
    <v-layout align-center justify-start>
      <v-btn
        v-if="history.length > 1"
        icon
        @click="goBack"
      >
        <v-icon color="gray-6">keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">{{ $t(`${namespace}.title`) }}</v-flex>
    </v-layout>

    <div>
      <v-tooltip max-width="177" top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="mx-0"
            icon
            @click="$router.push({
              name: 'CompanyGroup',
              params: {
                type: 'editar',
                id: data.companyGroup.id
              }
            })"
          >
            <v-icon color="gray-6">edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Common.edit') }}</span>
      </v-tooltip>

      <v-tooltip max-width="177" top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="mx-0"
            icon
            @click="openSingleDeleteDialog"
          >
            <v-icon color="gray-6">delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('Common.delete') }}</span>
      </v-tooltip>

      <v-btn icon @click="close()">
        <v-icon color="gray-6">close</v-icon>
      </v-btn>
    </div>

    <RemoveCompanyGroupDialog
      :visible="singleDeleteDialog"
      :companyGroup="data.companyGroup"
      @close="closeSingleDeleteDialog"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import RemoveCompanyGroupDialog from 'components/pages/company/companiesGroup/RemoveCompanyGroupDialog'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    action: {
      type: String,
      required: true
    },

    data: {
      type: Object,
      required: true
    }
  },
  components: {
    RemoveCompanyGroupDialog
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.companyGroup.header',
      singleDeleteDialog: false
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    openSingleDeleteDialog () {
      this.singleDeleteDialog = true
    },

    closeSingleDeleteDialog (reload) {
      this.singleDeleteDialog = false
      reload && this.close(reload)
    }
  }
}
</script>
